/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPhotographyWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPhotographyWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Capture the Moment!",
    "Photography Awaits!",
    "Let’s Snap Some Shots!",
  ],
  title: "Photography Workshop",
  description: "Organize a fun photography workshop.",
  longDescription:
    "Gather your friends for a creative photography workshop! Choose a date, decide on themes, and plan activities for the day!",
  emoji: "📸",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Photography Workshop",
          emoji: "📸",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the photography workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on photography themes?",
            description: "What themes should we follow during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What photography themes should we choose?",
                emoji: "🌅",
                completeAction: {
                  question: "Decide on locations?",
                  description: "Where do we want to take photos?",
                  addModules: [
                    {
                      type: ModuleType.Location,
                      doneType: ModuleDoneType.Voting,
                      title: "What locations should we consider?",
                      emoji: "🏞",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Capture Memories!",
    outroDescription:
      "Your photography workshop plans are set! Enjoy capturing beautiful moments!",
  },
};
